export default __webpack_public_path__ + "static/1196-19bac4fd668d1d08b15c1c46eb105932.gif";